import axios from "axios";

import Config from "../../../config";

// Valida o token no @BotFather, grava config.telegram no canal e registra o
// webhook do bot apontando para o lais-webhook.
const v1_actionTelegramConectar = (data) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/canais/telegram/connect`;
    return axios({
        method: "post",
        url: url,
        data: data
    });
};

export default v1_actionTelegramConectar;
